import { trackEvent } from '../lib/analytics';

interface RsvpClosedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function RsvpClosedModal({ isOpen, onClose }: RsvpClosedModalProps) {
  if (!isOpen) return null;

  const handleDownloadApp = () => {
    trackEvent('app_download_click', {
      source: 'rsvp_closed_modal',
    });
    window.open('https://in.invitd.us/GcbS4mkniZb', '_blank');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-900">RSVPs Closed</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-14 w-14 rounded-full bg-amber-100 mb-4">
            <svg className="h-7 w-7 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            RSVPs Have Been Closed
          </h3>
          <p className="text-gray-600 text-sm mb-5">
            The host is no longer accepting new RSVPs.
          </p>
        </div>

        {/* App Promotion */}
        <div className="bg-gradient-to-br from-sky-50 to-blue-50 rounded-xl p-4 mb-4 border border-sky-100">
          <p className="text-sm font-semibold text-gray-900 mb-1 text-center">
            Never Miss an RSVP Deadline Again ⏰
          </p>
          <p className="text-xs text-gray-600 text-center mb-3">
            Get reminders and manage all your events in one place
          </p>
          <button
            onClick={handleDownloadApp}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold py-2.5 px-4 rounded-lg transition-all duration-200 transform hover:scale-[1.02] text-sm"
          >
            Download Invitd Free
          </button>
        </div>

        <button
          onClick={onClose}
          className="w-full bg-gray-100 text-gray-700 py-2.5 px-6 rounded-lg font-medium hover:bg-gray-200 transition-colors text-sm"
        >
          Close
        </button>
      </div>
    </div>
  );
}

